import { Paragraph } from '@eggplant/pattern-library'

const SpaceEnvironmentsGeneral = () =>
  <Paragraph>
    <strong>
      After creating an environment, assign spaces from the edit page to make it availabe in those spaces.
    </strong>
  </Paragraph>

export default SpaceEnvironmentsGeneral
